import * as React from 'react';
import {
  Renderer,
  RendererComponentProps,
  ContextObserver,
  evaluate
} from '../webana';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { Subscriber, Broadcast } from 'react-broadcast';

interface RepeaterConfig {
  repeat: string;
  indexAssign: string;
  valueAssign: string;
  content: any;
}

@observer
export class RepeaterComponent extends React.Component<
  RendererComponentProps<RepeaterConfig> & ContextObserver<any>
> {
  render() {
    const { config, context } = this.props;
    const repeat = toJS(evaluate(config.repeat, context));
    if (Array.isArray(repeat)) {
      return repeat.map((x: any, i) => {
        let ctx = Object.assign({}, context);
        ctx[config.indexAssign || 'index'] = i;
        ctx[config.valueAssign || 'value'] = x;
        return (
          <Broadcast key={i} channel="context" value={ctx}>
            <Renderer content={config.content} />
          </Broadcast>
        );
      });
    }
    return <Renderer content={config.content} />;
  }
}

export class Repeater extends React.Component<
  RendererComponentProps<RepeaterConfig>
> {
  render() {
    return (
      <Subscriber channel="context">
        {ctx => <RepeaterComponent {...this.props} context={ctx} />}
      </Subscriber>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Repeater.tsx